import { useIntl } from 'react-intl';

import { INutritionInfo } from '@rbi-ctg/menu';

import { IUseselectedModiferNutritionFactsProps, NutritionFacts } from './types';
import { emptyNutritionFacts, getAllergenGroups } from './utils';

type UseNutritionFacts = (props: IUseselectedModiferNutritionFactsProps) => NutritionFacts[];

export const useNutritionModifierFacts: UseNutritionFacts = ({
  selectedModifer,
  useNutritionAllergenFromModifierMultiplier,
}) => {
  const { formatMessage } = useIntl();
  const nutritionFacts = [] as NutritionFacts[];
  const nutritionKeys = Object.keys(emptyNutritionFacts) as (keyof INutritionInfo)[];
  const nutritionInformation = useNutritionAllergenFromModifierMultiplier
    ? selectedModifer?.modifierMultiplier?.nutrition
    : selectedModifer?.nutrition;
  const allergenInformation = useNutritionAllergenFromModifierMultiplier
    ? selectedModifer?.modifierMultiplier?.allergen
    : selectedModifer?.allergen;
  if (selectedModifer && (nutritionInformation || allergenInformation)) {
    if (Object.keys(nutritionInformation || {})?.length) {
      const map = { ...emptyNutritionFacts };
      nutritionKeys.forEach(
        nutritionKey => (map[nutritionKey] += nutritionInformation?.[nutritionKey] ?? 0)
      );
      nutritionFacts.push({
        itemName: selectedModifer?.name?.locale || '',
        itemImage: selectedModifer?.image,
        facts: map,
        allergenGroups: allergenInformation
          ? getAllergenGroups(allergenInformation, formatMessage)
          : [],
        additionalItemInformation:
          selectedModifer?.modifierMultiplier?.modifier?.additionalInformationBlock,
      });
    }
  }

  return nutritionFacts;
};
